// src/components/appComponents/AppLoader.js
// Loading state in the app's design language.
//   <AppLoader />        full window (covers any navbar) — auth checks, sign-in hand-off
//   <AppLoader inline /> inside a page — a workspace or list that is still loading
import React from 'react';
import bumpups_logo from '../../assets/images/default/bumpups-logo-final.png';
import './appLoader.css';

const AppLoader = ({ inline = false, label }) => (
  <div className={`app-loader${inline ? ' app-loader--inline' : ''}`} role="status" aria-live="polite">
    {!inline && <img src={bumpups_logo} alt="Bumpups" className="app-loader-logo" />}
    <div className="app-loader-bar"><span /></div>
    <span className={label ? 'app-loader-label' : 'app-loader-sr'}>{label || 'Loading…'}</span>
  </div>
);

export default AppLoader;
